import {showEditAdditionalOptionsModal} from './Modals/EditAdditionalOptionsModal.js'
import {SHIPPER_NAMES} from '../../common/constants/ShipperNames.js'
import LabelConfigContext, {
  ENABLE_MODE__FULL,
  useLabelConfigContext,
} from './LabelConfigContext.js'
import {AdditionalProperties, LABEL_PROPERTIES} from './LabelConfigForm.js'

/**
 * List of enabled additional options and link to modal to edit additional label config options
 *
 * @param {Object} props
 * @param {String} props.shipperType
 * @param {Boolean} props.singleShipperType
 * @returns {React.ReactNode}
 */
export default function AdditionalOptionsSummary({
  shipperType,
  singleShipperType,
}) {
  const context = useLabelConfigContext()
  const {labelInfoID, onChange, isLabelEnableMode} = context

  return (
    <LabelConfigContext.Provider
      value={{...context, shipperType, isSummary: true}}
    >
      <li className="list__item list__item--shipper-addl-options fs-00 lh-md margin-top-25">
        {!singleShipperType && (
          <div className="margin-bottom-5">
            <span
              className={`wrap-shipper-addl-options wrap-shipper-addl-options-preset fs-n1 lh-sm unbold ${shipperType}`}
            >
              <span className="label__carrier-name">
                {SHIPPER_NAMES[shipperType]}
              </span>
            </span>
          </div>
        )}
        <div className="fs-n1 lh-md op-75 margin-bottom-5">
          <em>
            <AdditionalProperties
              shipperTypes={[shipperType]}
              properties={LABEL_PROPERTIES.preset_summary}
              onlyEnabled
            />
          </em>
        </div>
        <button
          className="btn btn--primary btn--primary-ol btn--xx-sm"
          type="button"
          id="edit_additional_options"
          onClick={() =>
            showEditAdditionalOptionsModal({
              labelInfoID,
              shipperType,
              onChange,
              isLabelEnableMode,
              enableMode: ENABLE_MODE__FULL,
            })
          }
        >
          View/Edit
        </button>
      </li>
    </LabelConfigContext.Provider>
  )
}
